import { render, staticRenderFns } from "./BookBottomBar.vue?vue&type=template&id=2c637196&"
import script from "./BookBottomBar.vue?vue&type=script&lang=js&"
export * from "./BookBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports